let _initProto, _initClass, _init_label, _init_extra_label, _init_value, _init_extra_value, _init_changeEvent, _init_extra_changeEvent;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { RadiantElement, customElement, event, onEvent, onUpdated, prop } from "@ecopages/radiant";
import { applyRovingTabindex, focusRovingItem, navigateRovingTabindex } from "@/lib/roving-tabindex";
let _RuiTree;
class RuiTree extends RadiantElement {
  static {
    ({
      e: [_init_label, _init_extra_label, _init_value, _init_extra_value, _init_changeEvent, _init_extra_changeEvent, _initProto],
      c: [_RuiTree, _initClass]
    } = _applyDecs(this, [customElement("rui-tree")], [[prop({
      type: String,
      defaultValue: ""
    }), 0, "label"], [prop({
      type: String,
      reflect: true,
      defaultValue: ""
    }), 0, "value"], [event({
      name: "rui-change",
      bubbles: true,
      composed: true
    }), 0, "changeEvent"], [onUpdated("value"), 2, "onValueUpdated"], [onEvent({
      selector: '[role="treeitem"]',
      type: "click"
    }), 2, "onClick"], [onEvent({
      selector: '[role="treeitem"]',
      type: "keydown"
    }), 2, "onKeydown"]], 0, void 0, RadiantElement));
  }
  constructor(...args) {
    super(...args);
    _init_extra_changeEvent(this);
  }
  label = (_initProto(this), _init_label(this));
  value = (_init_extra_label(this), _init_value(this));
  changeEvent = (_init_extra_value(this), _init_changeEvent(this));
  getVisibleItems() {
    return Array.from(this.querySelectorAll('[role="treeitem"]')).filter(item => {
      let node = item.parentElement;
      while (node && node !== this) {
        if (node.getAttribute("role") === "group" && node.hidden) {
          return false;
        }
        node = node.parentElement;
      }
      return true;
    });
  }
  getParentItem(item) {
    const group = item.closest('[role="group"]');
    if (!group) return null;
    const parent = group.previousElementSibling;
    return parent?.getAttribute("role") === "treeitem" ? parent : null;
  }
  /** Same-level treeitems as `item` (for `*` expand-siblings). */
  getSiblingItems(item) {
    const parent = this.getParentItem(item);
    const container = parent ? parent.nextElementSibling?.getAttribute("role") === "group" ? parent.nextElementSibling : null : this.querySelector('[role="tree"]') ?? this;
    if (!container) return [];
    return Array.from(container.querySelectorAll(':scope > li > [role="treeitem"], :scope > [role="treeitem"]'));
  }
  syncSelection() {
    const items = Array.from(this.querySelectorAll('[role="treeitem"]'));
    const visible = this.getVisibleItems();
    let activeIndex = 0;
    items.forEach((item, i) => {
      const id = item.getAttribute("data-value") || item.id || "";
      const selected = Boolean(this.value) && id === this.value;
      item.setAttribute("aria-selected", String(selected));
      if (selected) {
        const vis = visible.indexOf(item);
        if (vis >= 0) activeIndex = vis;
      } else if (!this.value && i === 0) {
        activeIndex = 0;
      }
    });
    applyRovingTabindex(visible, activeIndex);
  }
  syncExpanded() {
    const items = Array.from(this.querySelectorAll('[role="treeitem"]'));
    for (const item of items) {
      if (!item.hasAttribute("aria-expanded")) continue;
      const group = item.nextElementSibling;
      if (group?.getAttribute("role") === "group") {
        group.hidden = item.getAttribute("aria-expanded") === "false";
      }
    }
  }
  onConnected() {
    this.syncExpanded();
    this.syncSelection();
  }
  onValueUpdated() {
    this.syncSelection();
  }
  select(item) {
    const value = item.getAttribute("data-value") || item.id || item.textContent?.trim() || "";
    this.value = value;
    this.syncSelection();
    this.changeEvent.emit({
      value
    });
    item.focus();
  }
  setExpanded(item, expanded) {
    item.setAttribute("aria-expanded", String(expanded));
    const group = item.nextElementSibling;
    if (group?.getAttribute("role") === "group") group.hidden = !expanded;
    this.syncSelection();
  }
  onClick(event2) {
    const item = event2.target.closest('[role="treeitem"]');
    if (!item || !this.contains(item)) return;
    if (item.hasAttribute("aria-expanded")) {
      this.setExpanded(item, item.getAttribute("aria-expanded") !== "true");
    }
    this.select(item);
  }
  onKeydown(event2) {
    const current = event2.target.closest('[role="treeitem"]');
    if (!current) return;
    switch (event2.key) {
      case "ArrowDown":
      case "ArrowUp":
      case "Home":
      case "End":
        {
          const result = navigateRovingTabindex({
            items: this.getVisibleItems(),
            current,
            key: event2.key,
            orientation: "vertical",
            wrap: false
          });
          if (!result.handled) return;
          event2.preventDefault();
          break;
        }
      case "ArrowRight":
        {
          event2.preventDefault();
          if (current.getAttribute("aria-expanded") === "false") {
            this.setExpanded(current, true);
            return;
          }
          if (current.getAttribute("aria-expanded") === "true") {
            const items = this.getVisibleItems();
            const index = items.indexOf(current);
            if (items[index + 1]) focusRovingItem(items, index + 1);
          }
          break;
        }
      case "ArrowLeft":
        {
          event2.preventDefault();
          if (current.getAttribute("aria-expanded") === "true") {
            this.setExpanded(current, false);
            return;
          }
          const parent = this.getParentItem(current);
          if (parent) {
            const nextItems = this.getVisibleItems();
            const parentIndex = nextItems.indexOf(parent);
            if (parentIndex >= 0) focusRovingItem(nextItems, parentIndex);
          }
          break;
        }
      case "*":
        {
          event2.preventDefault();
          for (const sibling of this.getSiblingItems(current)) {
            if (sibling.hasAttribute("aria-expanded")) {
              this.setExpanded(sibling, true);
            }
          }
          break;
        }
      case "Enter":
        {
          event2.preventDefault();
          if (current.hasAttribute("aria-expanded")) {
            this.setExpanded(current, current.getAttribute("aria-expanded") !== "true");
          }
          this.select(current);
          break;
        }
      case " ":
        {
          event2.preventDefault();
          this.select(current);
          break;
        }
      default:
        break;
    }
  }
  static {
    _initClass();
  }
}
export { _RuiTree as RuiTree };